import React, { Component } from "react";
import util from "@util/index";
import "./index.less";

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  componentDidMount() {}

  render() {
    const { data, title } = this.props;
    const rankData = data;
    return (
      <div className="salesRank">
        <h4 className="rankingTitle">{title}</h4>
        <ul className="rankingList">
          {rankData.map((item, i) => (
            <li key={item.title}>
              <span className={`rankingItemNumber ${i < 3 ? "active" : ""}`}>
                {i + 1}
              </span>
              <span className="rankingItemTitle">{item.name}</span>
              <span className="rankingItemValue">
                {util.numberFormat(item.value)}
              </span>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/comm/charts/Rank/Rank.js